import BaseCrudService from "./baseCrud.service";

export default class TaxService extends BaseCrudService {

	constructor() {
		super('Tax');
	}

	save(tax) {
		return this.postRequest('Save', tax);
	}

	getDefault() {
		return this.getRequest('GetDefault');
	}

	getByCampaign(campaignId) {
		return this.getRequest('GetByCampaign', { campaignId });
	}

}